import { Pagination } from "antd";
import moment from "moment";
import { Link } from "react-router-dom";
import { Table } from "reactstrap";
import useRowSelection from "../../views/Admin/customHooks/useRowSelection";
const SaleOrderList = ({
  saleOrdersByCustomers,
  page,
  setPage,
  pageSize,
  totalPages,
}) => {
  const rowSelection = useRowSelection();
  const currentPage = page ?? rowSelection.currentPage;
  const currentSetPage = setPage ?? rowSelection.setCurrentPage;
  const currentTotal = totalPages ?? saleOrdersByCustomers?.length;
  const currentSize = pageSize ?? rowSelection.itemsPerPage;
  const data = page ? saleOrdersByCustomers : saleOrdersByCustomers?.slice(rowSelection.startIndex, rowSelection.endIndex);
  return (
    <div className="modern-table-container mt-2">

      {saleOrdersByCustomers?.length > 0 ? (
        <>
          <Table
            responsive
            hover
            className="modern-table modern-table-sm mb-0"
          >
            <thead>
              <tr>
                <th>SO Number</th>
                <th>Items</th>
                <th>Total</th>
                <th>Status</th>
                <th>Payment</th>
                <th>Created</th>
                <th className="text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              {data
                ?.map((i, index) => (
                  <tr key={i?._id}>
                    <td className="fw-bold">{i?.id ?? ""}</td>
                    <td>{i?.line_items?.length}</td>
                    <td className="fw-bold">
                      ${i?.total ? parseFloat(i?.total)?.toFixed(2) : 0}
                    </td>
                    <td>
                      <span className={`user-badge ${i?.status === 'complete' ? 'bg-success-soft' : 'bg-primary-soft'
                        }`}>
                        {i?.status ?? "n/a"}
                      </span>
                    </td>
                    <td>
                      <span className={`user-badge ${i?.paymentStatus === 'paid' ? 'bg-success-soft' : 'bg-warning-soft'
                        }`}>
                        {i?.paymentStatus ?? "unpaid"}
                      </span>
                    </td>
                    <td className="text-muted">{moment(i?.date_created).format("MM/DD/YYYY")}</td>
                    <td className="text-center">
                      <Link
                        to={{
                          pathname: `/admin/sale-order-details/${i?._id}`,
                          state: i,
                        }}
                        className="btn-action btn-edit text-decoration-none"
                      >
                        Details
                      </Link>
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>

          <div className="d-flex justify-content-end p-3 border-top bg-white">
            <Pagination
              size="small"
              current={currentPage}
              total={currentTotal}
              pageSize={currentSize}
              showSizeChanger={false}
              onChange={(val) => {
                currentSetPage(val);
              }}
            />
          </div>
        </>
      ) : (
        <div className="text-center py-5 text-muted fs-14 bg-white rounded-12">
          No active sale orders found for this customer.
        </div>
      )}
    </div>
  );
};
export default SaleOrderList;
